import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameLoaderDialogProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameLoaderDialogProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { AbstractPreloaderProperties } from "@lib/titan2/dist/game/view/properties/AbstractPreloaderProperties";
import { Point } from "pixi.js";
/**
* LoaderPortraitProperties.ts
*/
export class LoaderPortraitProperties extends GameLoaderDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position.set(522, 973); //the template is 10px off.
        this.versionFieldProperties.position.set(1014, 1870);
        this.versionFieldProperties.size = new Point(120, 50);
        this.playButtonProperties.position.set(75, 1630);
        this.playButtonProperties.textFieldProperties.size = new Point(900, 190);
        this.playButtonProperties.textFieldOffset.set(0, -15);
        this.playButtonProperties.scale.set(0.85);
        this.progressBarBackgroundProperties.position.set(287, 1690);
        this.progressBarProperties.position.set(21, 24);
        this.centerTextProperties.position.set(512, 953);
        this.centerTextProperties.size = new Point(662, 600);
        this.rightTextProperties.position.set(782, 1262);
        this.rightTextProperties.size = new Point(470, 340);
        this.rightTextProperties.visible = true;
        this.leftTextProperties.setHorizontalAlign(ControlConstants.CENTER);
        this.leftTextProperties.position.set(260, 1262);
        this.leftTextProperties.size = new Point(550, 340);
        this.leftTextProperties.visible = true;
        this.infoFieldFooterProperties.position.set(512, 1810);
        this.infoFieldFooterProperties.size = new Point(980, 80);
        this.copyrightProperties.position.set(512, 1890);
        this.copyrightProperties.size = new Point(760, 50);
        GameTextUtil.centerProperties(this.centerTextProperties);
    }
}
export class PreloaderPortraitProperties extends AbstractPreloaderProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spineProperties.position = new Point(512, 900);
        this.messageSpinePosition = new Point(875, 349);
        this.messageProperties.position = new Point(665, 550);
        this.messageProperties.size = new Point(940, 220);
        this.messageProperties.multiline = true;
    }
}
//# sourceMappingURL=LoaderPortraitProperties.js.map